import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useServiceAppState, useToast } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

import { getSnackbarInfos } from '../../utils/getSnackbarInfos';

import type { SnackbarKey } from '../../types';

/**
 * 알람을 띄우는 파라미터를 관리하는 훅입니다.
 * @description
 * - 스낵바 노출이 필요한 쿼리파라미터일 경우 내용에 따라 스낵바를 노출하고, 해당 파라미터를 제거합니다.
 */
const useToastParamEffect = () => {
  const router = useRouter();
  const { query } = router;
  const { enqueueToast } = useToast();
  const {
    state: { region, projectName, status },
  } = useServiceAppState();

  // 쿼리파라미터에 따라 스낵바 노출
  useEffect(() => {
    if (status !== STATUS_CODE.OK) return;
    const snackbarInfos = getSnackbarInfos(projectName, region);
    const targetSnackbarKey =
      Object.keys(snackbarInfos).find(key => query[key] !== undefined) || '';

    if (targetSnackbarKey.length > 0 && snackbarInfos[targetSnackbarKey as SnackbarKey]) {
      const { message, key } = snackbarInfos[targetSnackbarKey as SnackbarKey];

      enqueueToast(message(), {
        key,
        preventDuplicate: true,
      });

      // 쿼리 파라미터 업데이트
      const newQuery = { ...query };
      delete newQuery[targetSnackbarKey];

      router.replace(
        {
          pathname: router.pathname,
          query: newQuery,
        },
        '',
        { shallow: true },
      );
    }
  }, [enqueueToast, query, router, region, projectName, status]);
};

export default useToastParamEffect;
